import { render, staticRenderFns } from "./OperatorShifts.vue?vue&type=template&id=86276672&lang=pug&"
import script from "./OperatorShifts.vue?vue&type=script&lang=js&"
export * from "./OperatorShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports